import React from "react";
import SpeechBubble from "./index";
import {theme} from "../../theme/theme";
import {Platform, View} from "react-native";
import {AnimatedDots} from "../loader/AnimatedDots";

export const SpeechBubbleM = React.forwardRef((props, ref) => {
    const {
        texts,
        onNextPress,
        containerStyle,
        textStyle,
        position,
        noAnimation = false,
        allowSpeechReplay = false,
        hideIcons = true,
        onAnimationComplete = () => {},
        feedbackButtons,
        isLoading = false,
    } = props;

    return (
        <View style={{
            ...containerStyle
        }}>
            {isLoading ? (
                <View style={{
                    backgroundColor: theme.colors.lighter,
                    borderRadius: 15,
                    paddingVertical: 10,
                    marginTop:20,
                    width : '30%' ,
                    paddingHorizontal: 15,
                    alignItems: 'flex-start'
                }}>
                    <AnimatedDots size={8} color="#223F8F" />
                </View>
            ) : (
                <SpeechBubble
                    speeches={texts}
                    ref={ref}
                    noAnimation={noAnimation}
                    allowSkip={true}
                    allowSpeechReplay={allowSpeechReplay}
                    hideIcons={hideIcons}
                    writingDelay={Platform.OS === "ios" ? 10 : Platform.OS === "web" ? 20 : 1}
                    position={position}
                    onSpeechReplay={onNextPress}
                    speechBubbleStyle={{
                        backgroundColor: theme.colors.lighter,
                        borderRadius: 15,
                        paddingVertical: 10,
                        paddingHorizontal: 15,
                    }}
                    typeWriterStyle={{
                        color: theme.colors.grey,
                        fontFamily: "Montserrat-Medium",
                        ...textStyle
                    }}
                    onAnimationComplete={onAnimationComplete}
                    numberoflines={props.numberOfSpeechLines}
                />
            )}
            {feedbackButtons && (
                <View style={{
                    flexDirection: 'row',
                    gap: 8,
                    marginTop: 4,
                    alignSelf: position === 'left' ? 'flex-start' : 'center',
                }}>
                    {feedbackButtons}
                </View>
            )}
        </View>
    );
});